module.exports = __webpack_public_path__ + "static/zube-afe8f2475f3f5f1ef931b10645e41111.png";